import { IsNotEmpty, IsNumber, IsOneOfThese, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { CommissionData } from '../../api'
import { Expose, Transform } from 'class-transformer'
import { parseFloatNumber } from '@core/services/csv/CSVTransformer'
import { IDateService } from '@master/services/IDateService'
import { cid, container } from 'inversify-props'
import { FrequencyList, FrequencyOptions, FrequencyToValueMapping, FrequencyType } from '@master/model/options/FrequencyOptions'
import { productTypes } from '@master/model/options/LineOfBusinessOptions'

const dateService = container.get<IDateService>(cid.IDateService)
export class TransactionCsvModel extends CSVModelInterface implements CommissionData {
  filename = 'TransactionCSVTemplate'

  @Expose()
  @IsNotEmpty()
  private 'Adviser Company / Rep Code' = 'CODE 123'

  get advCode () {
    return this['Adviser Company / Rep Code']
  }

  @Expose()
  @IsNotEmpty()
  private 'Adviser Name' = 'Wen Adviser'

  get advName () {
    return this['Adviser Name']
  }

  @Expose()
  @IsNotEmpty()
  private 'Policy Number' = 'Policy 123'

  get policyNumber () {
    return this['Policy Number']
  }

  @Expose()
  @IsNotEmpty()
  private 'Client Name' = 'John Doe'

  get clientName () {
    return this['Client Name']
  }

  @Expose()
  @IsNotEmpty()
  private 'Product Name' = 'Life Insurance Name'

  get productName () {
    return this['Product Name']
  }

  @Expose()
  @IsNotEmpty()
  @IsOneOfThese(productTypes)
  private 'Product Type' = '[' + productTypes + ']'

  get productType () {
    return this['Product Type']
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Premium' = 123.45

  get premiumAmt () {
    return this.Premium
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  Commission = 123.45

  get commissionAmt () {
    return this.Commission
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'OR Commission' = 123.45

  get orCommissionAmt () {
    return this['OR Commission']
  }

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'Issued Date' = '31/12/2020'

  get issuedDate (): number {
    return dateService.toUnixMilliseconds(this['Issued Date'], 'DD/MM/YYYY')
  }

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'Paid To Date / Due Date' = '31/12/2020'

  get paidToDate (): number {
    return dateService.toUnixMilliseconds(this['Paid To Date / Due Date'], 'DD/MM/YYYY')
  }

  @Expose()
  @IsNotEmpty()
  @IsOneOfThese(FrequencyOptions.map(option => option.label))
  private 'Payment Mode' = '[' + FrequencyList + ']'

  get payMode () {
    return FrequencyToValueMapping(this['Payment Mode'] as FrequencyType)
  }
}
